import { render, staticRenderFns } from "./TenantBilling.vue?vue&type=template&id=5f1964c8&scoped=true&"
import script from "./TenantBilling.vue?vue&type=script&lang=js&"
export * from "./TenantBilling.vue?vue&type=script&lang=js&"
import style0 from "./TenantBilling.vue?vue&type=style&index=0&id=5f1964c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f1964c8",
  null
  
)

export default component.exports